import React from 'react';
import Flex from '../../data/Flex';
import UIFlex from '../UIFlex';
import Overlay from './Overlay';
import './LoadingOverlay.scss';
import './ManageUserOverlay.scss';
import { ManageUser } from '../../view/dashboard/main/ManageUser';
import { IUserData, handleSetIUserData } from '../../data/UserData';
import User from "../../data/User";

interface IAddUserOverlayDetails{
    title?:string;
    desc?:string;
}

interface IAddUserOverlayProps{
    hide:()=>void;
    details:IAddUserOverlayDetails;
}


export default class UserProfileOverlay extends React.Component<IAddUserOverlayProps>{

    defaultUserState:IUserData = {
        PK:User.state.pk,
        USERNAME:User.state.loginUsername,
        EMAIL:User.state.loginEmail,
        PHONE_NUMBER:User.state.phone_number,
        USER_ROLE:User.state.isAdminUser?"ADMIN":"TELECOMMUNICATOR",
        PASSWORD:"",
    }    
    
    static show=($id:string,$details:IAddUserOverlayDetails)=>{
        
        const hideOverlay = Overlay.show($id,{
            className:"manageUserOverlay",
            maxWidth:600,
            noPadding:true,
            content:(
                <UserProfileOverlay 
                    details={$details}                    
                    hide={()=>{
                        hideOverlay();
                    }}
                />
            ),
        });
        return hideOverlay;
    }
    
    static hide=($id:string)=>{
        Overlay.hide($id);
    }

    _cancel=()=>{
        this.props.hide();
    }

    _refresh=(phoneNumber?:string, email?:string, name?:string)=>{

        if(phoneNumber){
            User.state.phone_number=phoneNumber;
        }

        if(email){
            User.state.loginEmail=email;
        }

        if(name){
            User.state.loginUsername=name;
        }

        const userInfo = JSON.parse(User.storage.getItem("user")||"").summary;

        const newUpdatedUserInfo: any = {summary:{
                ...userInfo,
                "phone_number": User.state.phone_number,
                "email" : User.state.loginEmail,
                "username" : User.state.loginUsername}
        };

        localStorage.setItem("user",JSON.stringify(newUpdatedUserInfo));
            
    }

    render(){

     
        let title:string = this.props.details.title || "User Profile";
     
        return (
            <UIFlex flex={{direction:Flex.COLUMN,overflowHidden:true}}>
                <UIFlex className='userHeader' flex={{justifyContent:Flex.CENTER,alignItems:Flex.CENTER,overflowHidden:true}} >
                    {title}
                </UIFlex>
                <UIFlex flex={{justifyContent:Flex.CENTER,alignItems:Flex.CENTER}}>
                    
                    <ManageUser userData={this.defaultUserState} title={this.props.details.desc} onCancel={this._cancel} onRefresh={this._refresh}
                                action={"userProfile"} />                  
                </UIFlex>
            </UIFlex>
        );
        
    }
}

